import React, { useState } from "react";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import * as S from "./styles";
import AddIcon from "@material-ui/icons/Add";
import Save from "@material-ui/icons/Save";
import { API_HADES } from "shared/services";
import { useMainState } from "modules/app/contexts";
import { toast } from "react-toastify";
import * as _ from "lodash";
import { useTranslation } from "react-i18next";

function Rules() {
  const { user } = useMainState();
  const history = useHistory();
  const [rules, setRules] = useState([]);
  const { t } = useTranslation("Rules");
  const [rescueUsers, setRescueUsers] = useState([]);

  useEffect(() => {
    if (user.role == "seller") {
      history.push("/");
    }
  }, [user]);

  useEffect(() => {
    async function loadRules() {
      const result = await API_HADES.get("distribution/rules");

      const orderByDistribution = _.orderBy(result.data, "priority");

      const resizedRules = [];

      orderByDistribution.forEach((rule, index) => {
        resizedRules.push({
          ...rule,
          distribution: index + 1,
        });
      });

      setRules(resizedRules);
    }

    loadRules();
  }, []);

  function handleRemove(ruleId) {
    setRules([...rules.filter((rule) => rule.id != ruleId)]);

    API_HADES.delete(`/distribution/rules/${ruleId}`)
      .then(() => toast.success(t("Rules:remove")))
      .catch(() => toast.error(t("Rules:remove")));
  }

  function changeRule(index, newIndex) {
    const oldRules = [...rules];
    const ruleAux = oldRules[index];
    const rule = oldRules[newIndex];

    oldRules[index] = { ...rule, priority: ruleAux.priority };
    oldRules[newIndex] = { ...ruleAux, priority: rule.priority };

    setRules([...oldRules]);
  }

  function updateRules() {
    _.orderBy(rules).forEach(async (rule, index) => {
      await API_HADES.put(`/distribution/rules/${rule.id}`, {
        priority: index + 1,
      });
    });

    toast.success(t("Rules:updated"));
  }

  function handleSubmit() {
    const found = rules.some(
      (element) => element.distribution_type === "ByRescueUser"
    );
    if (found) {
      updateRules();
    } else {
      toast.error(t("Rules:error"));
    }
  }

  useEffect(() => {
    function loadRescueUser() {
      const byRescueUsers = rules.filter(
        (element) => element?.distribution_type === "ByRescueUser"
      );
      setRescueUsers(byRescueUsers);
    }
    loadRescueUser();
  }, [rules]);

  return (
    <S.GridContainer
      component="div"
      container
      justify="space-around"
      spacing={1}
    >
      <S.GridContent item>
        <S.Title>{t("Rules:order")}</S.Title>

        <S.CardContent>
          <S.OrderedListContent>
            <>
              <S.MemoryRuleContainer>
                <S.MemoryRuleContent>
                  <S.MemoryRuleCard>
                    <S.CardTitle
                      title={t("Rules:rule_memory")}
                      titleTypographyProps={{ style: { fontSize: "16px" } }}
                    />
                  </S.MemoryRuleCard>
                </S.MemoryRuleContent>
              </S.MemoryRuleContainer>

              {_.orderBy(rules, "priority").map((rule, index) => (
                <S.RulesCardList key={rule.id}>
                  <S.RulesContainer>
                    <S.RulesCard variant="outlined">
                      <S.RulesTitle
                        titleTypographyProps={{ style: { fontSize: "16px" } }}
                        props
                        title={rule.name || rule.id}
                        action={
                          <S.ArrowContainer>
                            {index != 0 && (
                              <S.ArrowButton
                                aria-label="settings"
                                onClick={() => changeRule(index, index - 1)}
                              >
                                <S.ArrowUp />
                              </S.ArrowButton>
                            )}

                            {index + 1 != rules.length && (
                              <S.ArrowButton
                                aria-label="settings"
                                onClick={() => changeRule(index, index + 1)}
                              >
                                <S.ArrowDown />
                              </S.ArrowButton>
                            )}
                          </S.ArrowContainer>
                        }
                      />
                    </S.RulesCard>

                    <S.IconsContainer>
                      <S.EditButton
                        onClick={() => {
                          history.push(`/app/rules/${rule.id}`);
                        }}
                        variant="round"
                      >
                        <S.EditIcon />
                      </S.EditButton>
                      {(rescueUsers.length > 1 ||
                        rule.distribution_type !== "ByRescueUser") && (
                        <S.DeleteButton
                          onClick={() => {
                            if (window.confirm(t("Rules:remove_alert"))) {
                              handleRemove(rule.id);
                            }
                          }}
                          variant="round"
                        >
                          <S.DeleteIcon />
                        </S.DeleteButton>
                      )}
                    </S.IconsContainer>
                  </S.RulesContainer>
                </S.RulesCardList>
              ))}
            </>
          </S.OrderedListContent>
        </S.CardContent>

        <S.ContainerButtons>
          <S.CreateRuleButton
            size="large"
            color="primary"
            aria-label="add"
            variant="outlined"
            onClick={() => history.push("/app/rules/new")}
          >
            <AddIcon />
            {t("Rules:create")}
          </S.CreateRuleButton>

          <S.SaveButton
            color="primary"
            aria-label="pencil"
            variant="extended"
            onClick={() => handleSubmit()}
          >
            <Save />
            {t("Rules:save")}
          </S.SaveButton>
        </S.ContainerButtons>
      </S.GridContent>
    </S.GridContainer>
  );
}

export default Rules;
